/**
 * Laat de browser een bestand downloaden (CSV, Excel, ...) zonder server-roundtrip.
 * Gedeelde helper: gebruik deze i.p.v. het anker-truc-patroon telkens opnieuw te bouwen.
 */
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.style.display = 'none';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Na de klik vrijgeven: de download heeft de URL dan al opgepikt.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

/** Tekst (bv. CSV) als bestand downloaden. */
export function downloadText(text: string, fileName: string, mimeType: string): void {
  downloadBlob(new Blob([text], { type: `${mimeType};charset=utf-8` }), fileName);
}
